/**
 * Official Walmart logo mark — yellow spark on the Walmart-blue tile.
 *
 * Use this wherever the Walmart brand is referenced so the UI shows the real
 * logo icon rather than a bare yellow star glyph.
 */
import React from "react";
import { ProductSourceBrandSvg } from "@/components/product/ProductSourceIconBar";
import { cn } from "@/lib/utils";
import "./walmart-logo.css";

export function WalmartLogoMark({ className, size = 13, title }) {
  // The official spark is slightly taller than it is wide (1345x1512 viewBox),
  // so the spark is inset from the tile to sit optically centered.
  const sparkW = Math.round(size * 0.58 * 10) / 10;
  const sparkH = Math.round(size * 0.66 * 10) / 10;
  return (
    <span
      className={cn("wm-logo-mark", className)}
      style={{
        width: size,
        height: size,
        borderRadius: Math.max(2, Math.round(size * 0.22 * 10) / 10),
      }}
      role={title ? "img" : undefined}
      aria-label={title || undefined}
      aria-hidden={title ? undefined : "true"}
      title={title || undefined}
    >
      <span className="wm-logo-spark" style={{ width: sparkW, height: sparkH }}>
        {ProductSourceBrandSvg.walmart}
      </span>
    </span>
  );
}

export default WalmartLogoMark;
